<template>
  <v-navigation-drawer
    v-if="user.email"
    app
    temporary
    :value="e_drawer"
    width="300"
    @input="updateEDrawerState"
  >
    <v-app-bar dark color="primary" flat>
      <v-img src="img/icons/logo-compa360.png" height="80" contain></v-img>
      <!-- 
      <v-toolbar-title
        class="font-weight-bold text-subtitle-1"
        v-text="'Agro'"
      />
      <span class="text-caption ml-2 mt-1" v-text="version" /> 
      -->
    </v-app-bar>
    <!-- Información pertinente al usuario actual -->
    <v-list v-if="user.email" dense>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon
            v-if="!user.avatar"
            class="primary--text"
            v-text="'mdi-emoticon'"
          >
          </v-icon>
          <v-img v-else :src="`${url_base}/storage/${user.avatar}`"> </v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="user.name"></v-list-item-title>
          <v-list-item-subtitle v-text="user.email"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-btn router to="/cuenta" class="primary--text" depressed block small>
          Cambiar contraseña
        </v-btn>
      </v-list-item>

      <!-- <v-divider></v-divider> -->

      <v-list-item
        :to="
          productor && productor.id
            ? `/ru/productor/${productor.id}`
            : '/ru/productor'
        "
        router
      >
        <v-list-item-icon>
          <v-icon v-text="'mdi-account-tie'" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> 1. Mi Perfil Propietario</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="sincronizarTodo">
        <v-list-item-icon>
          <v-icon v-text="'mdi-sync'" />
        </v-list-item-icon>
        <v-list-item-title v-text="`Guardar Mis Datos ${sync_all}`" />
      </v-list-item>
    </v-list>
    <!-- Información que se muestra cuando no hay ningún usuario actual en la aplicación -->
    <!--
      <v-list v-else dense>
      <v-list-item @click="showLogin">
        <v-list-item-avatar>
          <v-icon class="primary--text" v-text="'mdi-alert-circle'"> </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="'Bienvenido'"></v-list-item-title>
          <v-list-item-subtitle
            v-text="'Inicie sesión para continuar'"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list> 
    -->
    <!-- Lista con información pertinente al productor actual -->
    <!-- 
    <v-list dense>
     <v-list-item>
        <v-btn
          router
          :to="`/ru/productor/${productor.id}/clasificacion`"
          small
          block
          depressed
          class="primary--text"
        >
        Beneficiado Agrofamilia ? 
        </v-btn>
      </v-list-item>
      <v-divider inset /> 
      -->

    <!--
     <div class="text-center" v-if="productor">
        <div class="font-weight-bold">
          {{ productor.primer_nombre }} {{ productor.primer_apellido }}
        </div>
        <div class="grey--text">{{ productor.id }}</div>
      </div> 
      -->
    <!--
     <v-list-item
        v-if="productor"
        router
        :to="productor ? `/ru/productor/${productor.id}` : '/ru/productor'"
      >
        <v-list-item-avatar>
          <v-icon v-text="'mdi-account-tie'" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title> Mi Perfil Propietario</v-list-item-title>
        </v-list-item-content>
      </v-list-item> 
    </v-list> 
    -->
    <v-divider
      inset
      :style="{
        borderTopWidth: '3px',
        borderColor: 'black',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '75%',
      }"
    />

    <!-- <div class="text-center text-h6 font-weight-bold py-2 w-100">Menú</div> -->
    <!-- Listado con los enlaces a los distintos módulos del sistema incluyendo los reportes -->

    <!-- Botón del listado para sincronizar todos los formularios pendientes por sincronizar en el servidor -->
    <!-- <v-divider inset /> -->
    <!-- <v-list-item @click="sincronizarTodo">
        <v-list-item-icon>
          <v-icon v-text="'mdi-sync'" />
        </v-list-item-icon>
        <v-list-item-title v-text="`Guardar Mis Datos ${sync_all}`" />
      </v-list-item> -->

    <template v-for="(elemento, index) in elementosFiltrados">
      <v-list-item
        v-if="!elemento.group && !elemento.divider"
        :key="`v-list-item-${index}`"
        router
        exact
        :to="elemento.ruta"
        :disabled="!userCanNavigate(elemento.ruta)"
      >
        <v-list-item-icon>
          <v-icon v-text="elemento.icon" />
        </v-list-item-icon>
        <v-list-item-title v-text="elemento.texto" />
      </v-list-item>
      <v-divider
        v-else-if="elemento.divider"
        :key="`v-divider-${index}`"
        :inset="elemento.inset"
      >
      </v-divider>
      <v-list-group
        v-else-if="elemento.group"
        :key="`v-list-group-${index}`"
        :prepend-icon="elemento.icon"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-title v-text="elemento.texto" />
        </template>
        <template v-for="child in elemento.child">
          <v-list-item
            :key="child.texto"
            router
            exact
            :to="child.ruta"
            :disabled="!userCanNavigate(child.ruta)"
          >
            <v-list-item-title v-text="child.texto" />
          </v-list-item>
        </template>
      </v-list-group>
    </template>
    <v-list-group prepend-icon="mdi-help-circle" no-action>
      <template v-slot:activator>
        <v-list-item-title>Ayuda</v-list-item-title>
      </template>

      <v-list-item router :to="`/soporte`">
        <v-list-item-icon>
          <v-icon>mdi-lifebuoy</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Ayuda y Soporte</v-list-item-title>
      </v-list-item>

      <v-list-item router :to="`/ayuda`">
        <v-list-item-icon>
          <v-icon>mdi-book-open-page-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Preguntas Frecuentes</v-list-item-title>
      </v-list-item>
    </v-list-group>
    <!--
     <v-list-item router :to="`/soporte`">
        <v-list-item-icon>
          <v-icon v-text="'mdi-table'" />
        </v-list-item-icon>
        <v-list-item-title v-text="`Ayuda y Soporte`" />
      </v-list-item>
       <v-list-item router :to="`/ayuda`">
        <v-list-item-icon>
          <v-icon v-text="'mdi-table'" />
        </v-list-item-icon>
        <v-list-item-title v-text="`Preguntas Frecuentes`" />
      </v-list-item> 
      -->
    <v-list-item>
      <v-btn class="error--text" depressed block small @click="cerrarSesion">
        Cerrar sesión
      </v-btn>
    </v-list-item>

    <!--
    <v-list-item @click="logearReporte">
        <v-list-item-icon>
          <v-icon>mdi-table</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Reporte inter</v-list-item-title>
      </v-list-item>
       -->
    <!-- 
    <v-list-item @click="logearIMA(user)">
        <v-list-item-icon>
          <v-icon v-text="'mdi-table'" />
        </v-list-item-icon>
        <v-list-item-title v-text="`Reportes Comercialización`" />
      </v-list-item>
      <v-list-item href="/suagAPPAGRO/public/admin">
        <v-list-item-icon>
          <v-icon v-text="'mdi-shield-lock'" />
        </v-list-item-icon>
        <v-list-item-title v-text="`Admin`" />
      </v-list-item> 
      -->
    <!--  <v-list-item router to="/ru/listados">
        <v-list-item-icon>
          <v-icon v-text="'mdi-format-list-bulleted'" />
        </v-list-item-icon>
        <v-list-item-title v-text="`Listados offline`" />
      </v-list-item>  -->
    <!--  <v-list-item v-if="hasRole([5, 1])" @click="goToCedulaErrada">
        <v-list-item-icon>
          <v-icon>mdi-printer</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Cambio de Cédula Errada</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-else>
        <v-list-item-icon>
          <v-icon color="gray">mdi-printer</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title style="color: gray"
            >Cambio de Cédula Errada</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item> -->
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { url_base, rol_permitido } from '../utilidades'

// app version
const version = process.env.VUE_APP_VERSION
// roles a nivel de base de datos usados para definir
// que elementos mostrar en los listados
const registro = [1, 2, 5]
const reporte = [1, 3, 5]

export default {
  name: 'EDrawer',
  data: () => {
    return {
      version,
      url_base: url_base,
      registro: registro,
      reporte: reporte,
      elementos: [
        // { texto: 'Productores', ruta: '/ru/productores', icon: 'mdi-account' },
        // { divider: true, inset: true },
        /*  {
          texto: '1) Perfil',
          icon: 'mdi-city',
          ruta: '',
        }, */

        {
          texto: '2. Mi Finca',
          ruta: '/ru/fincas',
          icon: 'mdi-home-city-outline',
        },
        /*  {
          texto: '3.Potrero Galera Estanque',
          ruta: '/ru/parcelas',
          icon: 'mdi-view-dashboard',
        }, */
        {
          texto: '3.Producción, Venta',
          icon: 'mdi-sprout',
          group: true,
          child: [
            {
              texto: 'Acuiculturas',
              ruta: '/ru/acuiculturas',
              icon: 'mdi-fish',
            },
            { texto: 'Agricola', ruta: '/ru/cosechas', icon: 'mdi-seed' },
            {
              texto: 'Agroindustrias',
              ruta: '/ru/agroindustrias',
              icon: 'mdi-factory',
            },
            {
              texto: 'Agroturismos',
              ruta: '/ru/agroturismos',
              icon: 'mdi-map-marker-radius',
            },
            {
              texto: 'Apiculturas',
              ruta: '/ru/apiculturas',
              icon: 'mdi-flask',
            },
            { texto: 'Avicolas', ruta: '/ru/avicolas', icon: 'mdi-egg' },
            { texto: 'Forestales', ruta: '/ru/forestales', icon: 'mdi-tree' },
            { texto: 'Pecuarios', ruta: '/ru/pecuarios', icon: 'mdi-cow' },
            {
              texto: 'Embarcación',
              ruta: '/ru/embarcaciones',
              icon: 'mdi-ferry',
            },
            { texto: 'Pescas', ruta: '/ru/pescas', icon: 'mdi-fish' },
          ],
        },
        {
          texto: '4.Gráfica de Producción',
          ruta: '/ru/reportes/productor/info-produccion',
          icon: 'mdi-chart-line',
        },
        {
          texto: '5.Registro de Costos',
          ruta: '/ru/costos',
          icon: 'mdi-note-plus',
        },
        {
          texto: '6.Informe de Costos',
          ruta: '/ru/reportes/productor/reporte-costo',
          icon: 'mdi-file-chart',
        },
        {
          texto: '7.Contabilidad',
          ruta: '/ru/reportes/productor/contay-gestion',
          icon: 'mdi-scale-balance',
        },

        {
          texto: 'Tablero de Control',
          icon: 'mdi-chart-bar',
          group: true,
          child: [
            {
              texto: 'Producción Nac Actual',
              ruta: '/ru/reportes/productor/reporte-reservada',
              icon: 'mdi-earth',
            },
            {
              texto: 'Precios del Mercado',
              ruta: '/ru/reportes/productor/acpta',
              icon: 'mdi-currency-usd',
            },
          ],
        },
        {
          texto: 'Solicitud de Beneficios',
          ruta: '/ru/reportes/productor/serv-mida',
          icon: 'mdi-gift',
        },
        /* {
          texto: '7. Solicitud de Beneficios',
          ruta: '/ru/productor/beneficios',
          icon: 'mdi-gift',
        }, */
        {
          texto: 'Mis Empresas',
          ruta: '/ru/productor/empresa',
          icon: 'mdi-city-variant-outline',
        },
        {
          texto: 'Clima y Calendario',
          icon: 'mdi-weather-partly-cloudy',
          group: true,
          child: [
            {
              texto: 'Clima',
              ruta: '/ru/reportes/productor/clima-temperatura',
              icon: 'mdi-weather-cloudy-clock',
            },
            {
              texto: 'Calendario Agrícola',
              ruta: '/ru/reportes/productor/calendario-agricola',
              icon: 'mdi-calendar-month',
            },
          ],
        },
        {
          texto: 'Apoyos e Info Agro',
          icon: 'mdi-information-outline',
          group: true,
          child: [
            {
              texto: 'Apoyos a Productores',
              ruta: '/ru/reportes/productor/apoyos',
              icon: 'mdi-handshake-outline',
            },
            {
              texto: 'Apoyos para Arroz',
              ruta: '/ru/reportes/productor/compensaciones-arroz',
              icon: 'mdi-rice',
            },
            {
              texto: 'Apoyos para Maíz',
              ruta: '/ru/reportes/productor/compensaciones-maiz',
              icon: 'mdi-corn',
            },
            {
              texto: 'Apoyos para Leche',
              ruta: '/ru/reportes/productor/compensaciones-leche',
              icon: 'mdi-glass-mug-variant',
            },
            {
              texto: 'Alerta de Enfermedades ',
              ruta: '/ru/reportes/productor/vigilancia-fito',
              icon: 'mdi-virus-outline',
            },
            {
              texto: 'Leyes y Normas',
              ruta: '/ru/reportes/productor/leyes-normas',
              icon: 'mdi-gavel',
            },
          ],
        },
        /*         {
          texto: 'Comunidad -Proximamente',
          icon: 'mdi-account-group-outline',
          ruta: '',
        },
        {
          texto: 'Mercado Virtual-Proximamente',
          ruta: '',
          icon: 'mdi-cart-outline',
        }, */
        {
          texto: 'Agente de Empresas',
          icon: 'mdi-account-plus-outline',
          group: true,
          child: [
            {
              texto: 'Gestionar Empresas',
              ruta: '/ru/productor/empresa',
              icon: 'mdi-plus',
            },
            {
              texto: 'Agente de Productores',
              ruta: '/ru/productores',
              icon: 'mdi-account-multiple',
            },
          ],
        },
        /*  {
          texto: 'Ayuda',
          icon: 'mdi-leaf',
          child: [
            { texto: 'Preguntas Frecuentes', ruta: '/ru/preparaciones' },
            {
              texto: 'Contacto para Soporte Técnico',
              ruta: '/ru/preparaciones',
            },
          ],
          group: true,
        }, */
        /*  {
          texto: 'Certificaciones del Productor',
          ruta: '/ru/productor/formularioconsul',
          icon: 'mdi-printer',
        },
        { divider: true, inset: true },
        {
          texto: 'Consulta Expedientes',
          ruta: '/ru/productor/consulta',
          icon: 'mdi-warehouse',
        },
        { divider: true, inset: true },
        {
          texto: 'Procesa Datos Satelitales UTM',
          ruta: '/ru/productor/utmsave',
          icon: 'mdi-account',
        },
        {
          texto: 'Mapa Geoespacial y Satelitales',
          ruta: '/ru/reportes/productor/mapa-geoespacial',
          icon: 'mdi-account',
        },
        { divider: true, inset: true },
        {
          texto: 'Mapa de Productores',
          ruta: '/ru/reportes/productor/mapa-productor',
          icon: 'mdi-account',
        },
        {
          texto: 'Mapa de Siembras',
          ruta: '/ru/reportes/productor/mapa-siembra',
          icon: 'mdi-account',
        },
        {
          texto: 'Mapa de Cosechas',
          ruta: '/ru/reportes/productor/mapa-cosecha',
          icon: 'mdi-account',
        },
        { divider: true, inset: true },
        {
          texto: 'Procesa Imagenes del Satélite',
          ruta: '/ru/productor/tiffsave',
          icon: 'mdi-account',
        },
        {
          texto: 'Mapa:con Imágenes del Satélite',
          ruta: '/ru/productor/tiffsearch',
          icon: 'mdi-account',
        },
        { divider: true, inset: true },
        {
          texto: 'Reportes Operativos',
          icon: 'mdi-table',
          group: true,
          child: [
            { texto: 'Productores', ruta: '/ru/reportes/productores' },

            {
              texto: 'Producción Nacional',
              ruta: '/ru/reportes/productor/produccion-nacional',
            },
            {
              texto: 'Producción Detallada',
              ruta: '/ru/reportes/productor/produccion-detallada',
            },
            {
              texto: 'Producción Consolidada',
              ruta: '/ru/reportes/productor/produccion-consolidada',
            },
            {
              texto: 'Agricultura Familiar',
              ruta: '/ru/reportes/productor/agricultura-familiar',
            },
            {
              texto: 'Organizaciones y Productores Agrupados',
              ruta: '/ru/reportes/productor/organizaciones-y-productores',
            },
            {
              texto: 'Contratación y Beneficiados por Programas',
              ruta: '/ru/reportes/productor/contratacion-y-beneficiados',
            },
            {
              texto: 'Bitácora de Cambios',
              ruta: '/ru/reportes/productor/bitacora-de-cambios',
            },
            // { texto: 'Productor', ruta: '/ru/reportes/productor' },
            {
              texto: 'Trabajo y Familia',
              ruta: '/ru/reportes/productor/familia',
            },
            { texto: 'Finca > Rubros', ruta: '/ru/reportes/finca/rubro' },
            { texto: 'Finca > Tenencia', ruta: '/ru/reportes/finca/tenencia' },
            { texto: 'Acuicultura', ruta: '/ru/reportes/acuicultura' },
            { texto: 'Agroturismo', ruta: '/ru/reportes/agroturismo' },
            { texto: 'Apicultura', ruta: '/ru/reportes/apicultura' },
            { texto: 'Agroindustria', ruta: '/ru/reportes/agroindustria' },
            { texto: 'Artesanía', ruta: '/ru/reportes/artesania' },
            { texto: 'Forestal', ruta: '/ru/reportes/forestal' },
            { texto: 'Pecuario', ruta: '/ru/reportes/pecuario' },
            { texto: 'Pesca', ruta: '/ru/reportes/pesca' },
          ],
        }, */
        { divider: true, inset: true },
      ],
    }
  },
  computed: {
    e_drawer() {
      return this.$store.state.ui.e_drawer
    },
    ...mapState('registros', ['productor']),
    ...mapGetters('auth', ['user']),
    ...mapGetters('registros', ['sync_all']),
    //...mapState('ui', ['e_drawer']),

    elementosFiltrados() {
      if (!this.productor || !this.productor.actividad) {
        return this.elementos
      }
      // Convertir a array si es string
      let actividades = this.productor.actividad
      if (typeof actividades === 'string') {
        actividades = actividades.split(',').map((a) => a.trim().toLowerCase())
      }
      if (!Array.isArray(actividades) || actividades.length === 0) {
        return this.elementos
      }
      const equivalencias = {
        agricultura: 'Agricola',
        acuicultura: 'Acuiculturas',
        agroindustria: 'Agroindustrias',
        agroturismo: 'Agroturismos',
        apicultura: 'Apiculturas',
        avicola: 'Avicolas',
        forestal: 'Forestales',
        pecuario: 'Pecuarios',
        pesca: 'Pescas',
      }
      // Actividades normalizadas a textos de menú
      const actividadesNormalizadas = actividades
        .map((act) => equivalencias[act]) // convierte a texto del menú
        .filter(Boolean)

      return this.elementos.map((elemento) => {
        if (elemento.group && elemento.texto === '3.Producción, Venta') {
          const filteredChild = elemento.child.filter((child) =>
            actividadesNormalizadas.includes(child.texto)
          )
          return {
            ...elemento,
            child: filteredChild,
          }
        }
        return elemento
      })
    },
  },
  methods: {
    goToCedulaErrada() {
      this.$router.push('/ru/productor/cedulaerrada')
    },
    hasRole(roles) {
      return this.user.role_id.some((role) => roles.includes(role))
    },
    userCan(route) {
      return this.$store.getters['auth/userCan'](route)
    },
    userCanNavigate(route) {
      if (!route) return false
      if (
        (route.includes('reportes') || route.includes('consulta')) &&
        this.userCan(route).read
      )
        return true
      else if (
        (!route.includes('reportes') || !route.includes('consulta')) &&
        this.userCan(route).browse
      )
        return true
      else return false
    },
    rol_permitido: rol_permitido,

    // actualiza el estado del drawer en el state al abrirlo o cerrarlo
    updateEDrawerState(state) {
      this.$store.commit('ui/updateEDrawer', state)
      //this.e_drawer = state
    },

    // llama a la acción cerrarSesión del módulo de auth del store y redirige al usuario al login
    async cerrarSesion() {
      this.$store.dispatch('registros/cerrarSesion')
      //this.eliminarTodoDe(this.productor.id)
      await this.$store.dispatch('auth/cerrarSesion')
      if (this.$route.path !== '/bienvenido') {
        this.$router.push('/bienvenido')
      }
    },
    async eliminarTodoDe(id_productor) {
      try {
        this.loading_delete = true
        await this.$store.dispatch(
          'registros/eliminarDatosDeProductor',
          id_productor
        )
        this.listado_productores = null
        this.loading_delete = false
      } catch (e) {
        this.loading_delete = false
      }
    },

    // sincroniza todos los formularios pendientes por sincronizar
    async sincronizarTodo() {
      try {
        await this.$store.dispatch('registros/sincronizarTodo')
      } catch (error) {
        this.$sentry.captureException(error)
      }
    },

    showLogin() {
      this.$store.commit('ui/updateUnauthorizedModal', true)
    },
    async logearReporte() {
      try {
        // Llama a la acción Vuex con el namespace correcto
        const success = await this.$store.dispatch(
          'auth/logearCIIEPE',
          this.user
        )
        if (success) {
          this.$toast.success('Redirigiendo al reporte...')
        } else {
          this.$toast.error('No se pudo completar la operación.')
        }
      } catch (error) {
        console.error('Error al logear el reporte:', error)
        this.$toast.error('Hubo un error al procesar la solicitud.')
      }
    },
  },
}
</script>
